import React from 'react';
import PropTypes from 'prop-types';

import SMHeader from './Header';
import WrenchHeader from './wrench';
import { BRAND, HEADER_COLOR, HEADER_VARIANT } from './enums';
import { ValidMenuNameList } from './config/linkInfo';

const Header = ({
  isAnonHeaderSticky,
  color,
  isUserAuthenticated,
  showCreateSurveyButton,
  lang,
  variant,
  isEUDC,
  actionFlow,
  user,
  isMRX,
  displayLICTA,
  showDrawer,
  excludeMenuItems,
  showLoginButton,
  showSignupButton,
  alwaysUseAnonymousNav,
  Logo,
  brand,
  wrenchVariant,
  title,
}) => {
  const { session } = user;

  return (
    <>
      {user.isAuthenticated && isUserAuthenticated ? (
        <WrenchHeader
          variant={wrenchVariant}
          title={title}
          isEUDC={isEUDC}
          lang={lang}
          session={session}
        />
      ) : (
        <SMHeader
          isAnonHeaderSticky={isAnonHeaderSticky}
          color={color}
          isUserAuthenticated={isUserAuthenticated}
          showCreateSurveyButton={showCreateSurveyButton}
          lang={lang}
          variant={variant}
          isEUDC={isEUDC}
          actionFlow={actionFlow}
          user={user}
          isMRX={isMRX}
          displayLICTA={displayLICTA}
          showDrawer={showDrawer}
          excludeMenuItems={excludeMenuItems}
          showLoginButton={showLoginButton}
          showSignupButton={showSignupButton}
          alwaysUseAnonymousNav={alwaysUseAnonymousNav}
          Logo={Logo}
          brand={brand}
        />
      )}
    </>
  );
};

Header.propTypes = {
  isAnonHeaderSticky: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(HEADER_COLOR)),
  isUserAuthenticated: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  showCreateSurveyButton: PropTypes.bool,
  lang: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.values(HEADER_VARIANT)),
  isEUDC: PropTypes.bool.isRequired,
  actionFlow: PropTypes.string,
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  isMRX: PropTypes.bool,
  displayLICTA: PropTypes.bool,
  showDrawer: PropTypes.bool,
  excludeMenuItems: PropTypes.arrayOf(PropTypes.oneOf(ValidMenuNameList)),
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  alwaysUseAnonymousNav: PropTypes.bool,
  Logo: [PropTypes.node, PropTypes.object],
  brand: PropTypes.oneOf(Object.values(BRAND)),
  wrenchVariant: PropTypes.string,
  title: PropTypes.string,
};

Header.defaultProps = {
  isAnonHeaderSticky: true,
  color: 'primary',
  isUserAuthenticated: false,
  showCreateSurveyButton: true,
  displayLICTA: true,
  showDrawer: true,
  variant: 'default',
  actionFlow: 'header',
  isMRX: false,
  excludeMenuItems: [],
  showLoginButton: true,
  showSignupButton: true,
  alwaysUseAnonymousNav: false,
  Logo: undefined,
  brand: BRAND.SURVEYMONKEY,
  wrenchVariant: 'default',
  title: undefined,
};

export default Header;

export { Header };
